<template>
    <div class="accordion" role="tablist">
        {{ tipo_id }}
        <b-card
            no-body
            class="mb-1"
            v-for="(item, index) in itens"
            :key="index"
        >
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                    block
                    size="sm"
                    variant="light"
                    v-b-toggle="`accordion-${id}-${index}`"
                    v-on:click="toggleItem(id, index)"
                >
                    <div
                        class="d-flex align-items-center justify-content-between"
                    >
                        <span class="text-uppercase">
                            <strong
                                >{{ isActive(index) ? "-" : "+" }}
                                {{ item.name }}
                            </strong></span
                        >
                        <slot name="header" v-bind:item="item"></slot>
                    </div>
                </b-button>
            </b-card-header>
            <b-collapse
                :id="`accordion-${id}-${index}`"
                accordion="accordion-group"
                role="tabpanel"
            >
                <b-card-body>
                    <slot name="content" v-bind:item="item"></slot>
                </b-card-body>
            </b-collapse>
        </b-card>
    </div>
</template>
<script>
export default {
    props: {
        id: { required: true },
        value: Number,
        data_itens: Array
    },
    watch: {
        tipo_id(newVal) {
            this.$emit("input", newVal);
        }
    },
    data() {
        return {
            tipo_id: null,
            itens: [],
            toggled: null
        };
    },
    created() {
        this.tipo_id = this.value;
        this.itens = this.data_itens;
    },
    methods: {
        isActive(item) {
            this.tipo_id = item.id;
            return this.toggled == item;
        },
        toggleItem(id, item) {
            if (this.toggled == item) {
                this.toggled = null;
            } else {
                this.toggled = item;
            }
        }
    }
};
</script>
